import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'deliveryTime',
  standalone: true,
})
export class DeliveryTimePipe implements PipeTransform {
  transform(
    input: string | undefined,
    timezone?: string,
    format: 'display' | 'local' | 'full' = 'display'
  ): string {
    if (!input) return 'N/A';

    try {
      let date: Date;

      if (input.includes('T') || input.includes('-')) {
        if (!input.endsWith('Z') && !input.includes('+')) {
          date = new Date(input + 'Z');
        } else {
          date = new Date(input);
        }
      } else {
        const [hours, minutes] = input.split(':').map(part => parseInt(part, 10));
        date = new Date();
        date.setUTCHours(hours, minutes, 0, 0);
      }

      if (isNaN(date.getTime())) {
        throw new Error('Invalid date format');
      }

      if (format === 'local') {
        const localTime = date.toLocaleTimeString([], {
          hour: 'numeric',
          minute: '2-digit',
          hour12: true,
        });
        const localZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        return `${localTime} (${localZone})`;
      } else if (format === 'full') {
        const options: Intl.DateTimeFormatOptions = {
          month: 'short',
          day: 'numeric',
          year: 'numeric',
          hour: 'numeric',
          minute: '2-digit',
          hour12: true,
          timeZone: timezone || undefined
        };

        const formattedTime = new Intl.DateTimeFormat('en-US', options).format(date);
        const tzAbbr = this.getTimezoneAbbreviation(date, timezone);
        return formattedTime + (tzAbbr ? ` (${tzAbbr})` : '');
      } else {
        const options: Intl.DateTimeFormatOptions = {
          hour: 'numeric',
          minute: '2-digit',
          hour12: true,
          timeZone: timezone || undefined
        };

        const formattedTime = new Intl.DateTimeFormat('en-US', options).format(date);
        const tzAbbr = this.getTimezoneAbbreviation(date, timezone);
        return formattedTime + (tzAbbr ? ` (${tzAbbr})` : '');
      }
    } catch (error) {
      console.error('Error formatting delivery time:', error);
      return 'Invalid Time';
    }
  }

  private getTimezoneAbbreviation(date: Date, timezone?: string): string | undefined {
    if (!timezone) return undefined;

    return new Intl.DateTimeFormat('en-US', {
      timeZone: timezone,
      timeZoneName: 'short',
    })
      .formatToParts(date)
      .find((part) => part.type === 'timeZoneName')?.value;
  }
}
